// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: var(--vb-font), system-ui, -apple-system, 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--vb-text);
  background-color: var(--vb-bg);
  background-image: none;
  transition: background-color 0.3s ease, color 0.3s ease;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html, body, #root, .App {
  height: 100%;
  margin: 0;
  padding: 0;
}

.App {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  color: var(--vb-text);
}

h1, h2, h3 {
  font-family: inherit;
  letter-spacing: -0.02em;
  text-transform: none;
  color: var(--vb-text);
}

button, input, select, textarea {
  font-family: inherit;
}

button {
  padding: 10px 15px;
  border: none;
  border-radius: var(--vb-radius-sm);
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s, color 0.2s, transform 0.15s;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,6EAA6E;EAC7E,mCAAmC;EACnC,kCAAkC;EAClC,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE;aACW;AACb;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["body {\n  margin: 0;\n  font-family: var(--vb-font), system-ui, -apple-system, 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--vb-text);\n  background-color: var(--vb-bg);\n  background-image: none;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nhtml, body, #root, .App {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n\n.App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  color: var(--vb-text);\n}\n\nh1, h2, h3 {\n  font-family: inherit;\n  letter-spacing: -0.02em;\n  text-transform: none;\n  color: var(--vb-text);\n}\n\nbutton, input, select, textarea {\n  font-family: inherit;\n}\n\nbutton {\n  padding: 10px 15px;\n  border: none;\n  border-radius: var(--vb-radius-sm);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.2s, color 0.2s, transform 0.15s;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
